import { FieldErrors } from "react-hook-form"

export const useHasErrors = () => {
    const hasErrors = (field: string, errors: FieldErrors<any>) =>{
        if (Object.keys(errors).some(key => key == field)) return true
    }

    const getErrorMessage = (field: string, errors: FieldErrors<any>): string | undefined => {
        const message = errors[field]?.message || "";
        return String(message)
    }

    return {
        hasErrors,
        getErrorMessage
    }
}